import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import Dropdown from './Dropdown';
import { SelectItem } from 'src/models/common/SelectItem';

interface IPagedDropdownProps {
    label?: string;
    onChange?: (selectItem: SelectItem) => void;
    items?: SelectItem[];
    size?: 'small' | 'medium' | 'large';
    value?: number | string;
}

const PagedDropdown = (props: IPagedDropdownProps) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {
        const idx = _.findIndex(props.items, { id: props.value });
        setSelectedIndex(idx);
    }, [props.value]);

    const actionButton = (action: 'prev' | 'next') => {
        const isFirst = selectedIndex === 0;
        const isLast = props.items && selectedIndex === props.items.length - 1;

        const className = `dlc-button-input ${props.size || 'small'} ${
            (isFirst && action === 'prev') || (isLast && action === 'next') ? 'disabled' : ''
        }`;
        const actionText = action === 'prev' ? '< Prev' : 'Next >';
        let actionFn: () => void = undefined;

        if (action === 'prev' && !isFirst && props?.items && selectedIndex > 0) {
            actionFn = () => {
                props.onChange(props.items[selectedIndex - 1]);
            };
        } else if (action === 'next' && !isLast && props?.items && props.items.length > selectedIndex) {
            actionFn = () => {
                props.onChange(props.items[selectedIndex + 1]);
            };
        }

        return (
            <span className={className} onClick={actionFn}>
                <span>{actionText}</span>
            </span>
        );
    };

    return (
        <span>
            {actionButton('prev')}
            <Dropdown {...props} />
            {actionButton('next')}
        </span>
    );
};

export default PagedDropdown;



// WEBPACK FOOTER //
// ./src/components/controls/PagedDropdown.tsx